const { MButton2, MInput, MLabel, MSelect } = require("components/forms");

export class FormTitleAConfigurator {
  static extCode = {
    LaureaScienzeFormazionePrimariaVO: "LAU_FORPRIM_VO",
    LaureaScienzeFormazionePrimaria249: "LAU_FORPRIM_249",
    DiplomaMagistraleAA20012002: "DIPMAG",
    SpecializzazioneSostegno: "CT",
    Pas: "PAS",
    cfu60: "ALTRO", //TODO: chiedere un codice a MArco Aveta e sostituire
    Ssis: "SSIS",
    COBASLID: "COBASLID",
    DiplomaAccademicoAFAM: "AFAM II",
    DiplomaDidatticaMusica: "DIAMUSI",
    ConcorsoTitoliEsami: "CONC",
    SessioniRiservateAbilitazioni: "CONC",
    Tfa: "TFA",
    TitoloEsteroRiconosciuto: "TITPR_EST",
    TitoloEsteroPresentataDomandaRiconoscimento: "EST_SEC_2019",
  };

  static forms = [
    {
      template: "LaureaScienzeFormazionePrimariaVO",
      label:
        'Laurea in Scienze della Formazione Primaria Legge 341/1990 "vecchio ordinamento"',
    },
    {
      template: "LaureaScienzeFormazionePrimaria249",
      label:
        "Laurea in Scienze della Formazione Primaria DM 249/2010 classe LM-85 bis",
    },
    {
      template: "DiplomaMagistraleAA20012002",
      label: `Diploma magistrale conseguito entro l'anno accademico 2001/2002`,
    },
    {
      template: "SpecializzazioneSostegno",
      label: `Specializzazione sul sostegno (D.M. 30 settembre 2011)`,
    },
    {
      template: "TFAIndire75",
      label: `Specializzazione sul sostegno (D.M. 75/2025) - Triennalisti/INDIRE`,
    },
    {
      template: "TFAIndire77",
      label: `Specializzazione sul sostegno (D.M. 77/2025) - Estero/INDIRE`,
    },
    {
      template: "Tfa",
      label: `Tirocinio Formativo Attivo (non selezionare in caso di specializzazione sul sostegno)`,
    },
    {
      template: "Pas",
      label: `PAS (Percorso Abilitante Speciale)`,
    },
    {
      template: "cfu60",
      label: `Percorsi abilitanti ai sensi del DPCM 4 agosto 2023`,
    },
    {
      template: "Ssis",
      label: `SSIS (Scuola di Specializzazione per l'Insegnamento Secondario)`,
    },
    {
      template: "COBASLID",
      label: `COBASLID (per la scuola secondaria)`,
    },
    /*
          SAVERIO: 
            1. eliminato su richeista di Pina via teams il 19.11.2025 ore 11:00 
            2. rimesso su richiesta di Pina via teams il 11.12.2025 ore 12:37 ma con diciture diverse
            3. ri-eliminato su richiesta di Pina via teams il 12.12.2025 ore 14:45    
    {
      template: "DiplomaAccademicoAFAM",
      label: `Diploma accademico di II livello rilasciato da Istituzione AFAM per l'insegnamento dell'Educazione musicale (Legge n. 508/1999)`,
    },
    */
    {
      template: "DiplomaDidatticaMusica",
      label: `Diploma di Didattica della Musica (Legge 268/2002)`,
    },
    {
      template: "ConcorsoTitoliEsami",
      label: `Concorso per titoli ed esami`,
    },
    {
      template: "SessioniRiservateAbilitazioni",
      label: `Sessioni riservate di abilitazione`,
    },
    {
      template: "TitoloEsteroRiconosciuto",
      label: `Titolo accademico conseguito all'estero e riconosciuto abilitante all'insegnamento con apposito decreto del MIUR`,
    },
    /*
      MANUELA: 
            1. eliminato su richeista di Francesco via teams il 29.01.2026 ore 09:50 
    {
      template: "TitoloEsteroPresentataDomandaRiconoscimento",
      label: `Titolo accademico di accesso conseguito all'estero per il quale è stata presentata la relativa domanda di riconoscimento alla Direzione Generale per gli ordinamenti scolastici e la valutazione del sistema nazionale di istruzione`,
    },*/
  ];

  static LaureaScienzeFormazionePrimariaVO = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label:
          "Indirizzo (solo per laurea conseguita ai sensi del DM 26 maggio 1998)",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_LaureaScienzeFormazionePrimariaVO = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static LaureaScienzeFormazionePrimaria249 = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label:
          "Indirizzo (solo per laurea conseguita ai sensi del DM 26 maggio 1998)",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo ",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_LaureaScienzeFormazionePrimaria249 = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static DiplomaMagistraleAA20012002 = [
    [
      {
        id: "searchSchool",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Istituto",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso la scuola",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "province",
        field: "province",
        label: "Provincia",
        component: MInput,
        type: "text",
        className: "col-md-4",
        readOnly: true,
      },
      {
        id: "address",
        field: "address",
        label: "Via",
        component: MInput,
        type: "text",
        className: "col-md-8",
        readOnly: true,
      },
    ],
    [
      {
        id: "durata",
        field: "durata",
        label: "Durata",
        component: MInput,
        type: "number",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_DiplomaMagistraleAA20012002 = {
    istitution: "",
    city: "",
    province: "",
    address: "",
    durata: "",
    dataConseguimento: "",
  };

  static SpecializzazioneSostegno = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Ordine di scuola",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Scuola dell'Infanzia", value: "Scuola dell'Infanzia" },
            { label: "Scuola Primaria", value: "Scuola Primaria" },
            {
              label: "Scuola Secondaria di I Grado",
              value: "Scuola Secondaria di I Grado",
            },
            {
              label: "Scuola Secondaria di II Grado",
              value: "Scuola Secondaria di II Grado",
            },
          ],
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText:
          "inserire formato AAAA/AAAA (N.B. l'anno accademico di riferimento della specializzazione sul sostegno potrebbe essere quello di emanazione del bando e non quello successivo di effettiva frequenza del corso.)",
        className: "col-md-6 pt-3",
      },
    ],
    [
      {
        id: "ciclo",
        field: "ciclo",
        label: "Ciclo",
        component: MInput,
        className: "col-md-2 pt-3",
      },
    ],
  ];

  static dv_SpecializzazioneSostegno = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
    ciclo: "",
  };

  static institutions_TFAIndire75 = [
    { label: "Selezionare", value: "" },
    {
      label:
        "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
      value:
        "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
    },
    {
      label: "Università della Basilicata",
      value: "Università della Basilicata",
    },
    { label: "Università della Calabria", value: "Università della Calabria" },
    {
      label: "Università Mediterranea di Reggio Calabria",
      value: "Università Mediterranea di Reggio Calabria",
    },
    {
      label: "Università Suor Orsola Benincasa di Napoli",
      value: "Università Suor Orsola Benincasa di Napoli",
    },
    {
      label: `Università Telematica "Giustino Fortunato"`,
      value: `Università Telematica "Giustino Fortunato"`,
    },
    {
      label: `Università Telematica "Pegaso"`,
      value: `Università Telematica "Pegaso"`,
    },
    { label: "Università di Parma", value: "Università di Parma" },
    {
      label: "Università di Cassino e del Lazio meridionale",
      value: "Università di Cassino e del Lazio meridionale",
    },
    {
      label: "Università Europea di Roma",
      value: "Università Europea di Roma",
    },
    {
      label: `Università degli Studi di Roma "Foro Italico"`,
      value: `Università degli Studi di Roma "Foro Italico"`,
    },
    {
      label: `Libera Università "Maria SS Assunta" - LUMSA di Roma`,
      value: `Libera Università "Maria SS Assunta" - LUMSA di Roma`,
    },
    {
      label: `Università "Saint Camillus International"`,
      value: `Università "Saint Camillus International"`,
    },
    {
      label: `Università Telematica "Universitas Mercatorum"`,
      value: `Università Telematica "Universitas Mercatorum"`,
    },
    {
      label: "Università Cattolica Sacro Cuore",
      value: "Università Cattolica Sacro Cuore",
    },
    { label: "Università della Tuscia", value: "Università della Tuscia" },
    {
      label: `Università di Urbino "Carlo Bò"`,
      value: `Università di Urbino "Carlo Bò"`,
    },
    { label: "Università di Foggia", value: "Università di Foggia" },
    { label: "Università del Salento", value: "Università del Salento" },
    { label: "Università di Palermo", value: "Università di Palermo" },
    { label: "Università di Siena", value: "Università di Siena" },
    { label: "Università di Perugia", value: "Università di Perugia" },
    { label: "Università di Verona", value: "Università di Verona" },
    { label: "Università di Bologna", value: "Università di Bologna" },
    { label: "Università di Roma Tre", value: "Università di Roma Tre" },
    {
      label: "Università Studi Internazionali di Roma - UNINT",
      value: "Università Studi Internazionali di Roma - UNINT",
    },
    { label: "Università di Cagliari", value: "Università di Cagliari" },
    { label: "Università di Firenze", value: "Università di Firenze" },
    {
      label: "Università Modena-Reggio Emilia",
      value: "Università Modena-Reggio Emilia",
    },
    {
      label: "Università telematica Unicusano - Roma",
      value: "Università telematica Unicusano - Roma",
    },
    { label: "Università di Macerata", value: "Università di Macerata" },
    { label: "Università di Bari", value: "Università di Bari" },
    { label: "Università di Padova", value: "Università di Padova" },
    { label: "Università di Salerno", value: "Università di Salerno" },
    {
      label: `Università degli Studi "Link Campus University"`,
      value: `Università degli Studi "Link Campus University"`,
    },
    {
      label: `Università telematica "e-Campus"`,
      value: `Università telematica "e-Campus"`,
    },
    { label: "Università del Molise", value: "Università del Molise" },
    {
      label: `Università LUM "Giuseppe Degennaro"`,
      value: `Università LUM "Giuseppe Degennaro"`,
    },
    { label: "Università di Messina", value: "Università di Messina" },
    {
      label: "Università per Stranieri di Reggio Calabria",
      value: "Università per Stranieri di Reggio Calabria",
    },
    {
      label: `Università UKE "Kore" di Enna`,
      value: `Università UKE "Kore" di Enna`,
    },
  ];

  static TFAIndire75 = [
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso",
        component: MSelect,
        payload: { options: FormTitleAConfigurator.institutions_TFAIndire75 },
        className: "col-md-6",
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Ordine di scuola",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Scuola dell'Infanzia", value: "Scuola dell'Infanzia" },
            { label: "Scuola Primaria", value: "Scuola Primaria" },
            {
              label: "Scuola Secondaria di I Grado",
              value: "Scuola Secondaria di I Grado",
            },
            {
              label: "Scuola Secondaria di II Grado",
              value: "Scuola Secondaria di II Grado",
            },
          ],
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MSelect,
        payload: {
          options: [
            { label: "Seleziona anno accademico", value: "" },
            { label: "2024/2025", value: "2024/2025" },
            { label: "2025/2026", value: "2025/2026" },
          ],
        },
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_TFAIndire75 = {
    description: "",
    istitution: "",
    aa: "",
    dataConseguimento: "",
  };

  static institutions_TFAIndire77 = [
    { label: "Selezionare", value: "" },
    {
      label:
        "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
      value:
        "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
    },
    {
      label: "Università della Basilicata",
      value: "Università della Basilicata",
    },
    { label: "Università della Calabria", value: "Università della Calabria" },
    {
      label: "Università Mediterranea di Reggio Calabria",
      value: "Università Mediterranea di Reggio Calabria",
    },
    {
      label: "Università Suor Orsola Benincasa di Napoli",
      value: "Università Suor Orsola Benincasa di Napoli",
    },
    {
      label: `Università Telematica "Giustino Fortunato"`,
      value: `Università Telematica "Giustino Fortunato"`,
    },
    {
      label: `Università Telematica "Pegaso"`,
      value: `Università Telematica "Pegaso"`,
    },
    {
      label: "Università di Cassino e del Lazio meridionale",
      value: "Università di Cassino e del Lazio meridionale",
    },
    {
      label: "Università Europea di Roma",
      value: "Università Europea di Roma",
    },
    {
      label: `Università "Saint Camillus International"`,
      value: `Università "Saint Camillus International"`,
    },
    {
      label: `Università Telematica "Universitas Mercatorum"`,
      value: `Università Telematica "Universitas Mercatorum"`,
    },
    {
      label: "Università Studi Internazionali di Roma - UNINT",
      value: "Università Studi Internazionali di Roma - UNINT",
    },
    { label: "Università di Salerno", value: "Università di Salerno" },
    {
      label: `Università degli Studi "Link Campus University"`,
      value: `Università degli Studi "Link Campus University"`,
    },
    {
      label: `Università telematica "e-Campus"`,
      value: `Università telematica "e-Campus"`,
    },
    {
      label: "Università per Stranieri di Reggio Calabria",
      value: "Università per Stranieri di Reggio Calabria",
    },
  ];

  static TFAIndire77 = [
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso",
        component: MSelect,
        payload: { options: this.institutions_TFAIndire77 },
        className: "col-md-6",
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Ordine di scuola",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Scuola dell'Infanzia", value: "Scuola dell'Infanzia" },
            { label: "Scuola Primaria", value: "Scuola Primaria" },
            {
              label: "Scuola Secondaria di I Grado",
              value: "Scuola Secondaria di I Grado",
            },
            {
              label: "Scuola Secondaria di II Grado",
              value: "Scuola Secondaria di II Grado",
            },
          ],
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MSelect,
        payload: {
          options: [
            { label: "Seleziona anno accademico", value: "" },
            { label: "2024/2025", value: "2024/2025" },
            { label: "2025/2026", value: "2025/2026" },
          ],
        },
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_TFAIndire77 = {
    description: "",
    istitution: "",
    aa: "",
    dataConseguimento: "",
  };

  static Pas = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Classe di abilitazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "ciclo",
        field: "ciclo",
        label: "Ciclo",
        component: MInput,
        className: "col-md-2 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_Pas = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
    ciclo: "",
  };

  static cfu60 = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Classe di abilitazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_cfu60 = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static Ssis = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Classe di abilitazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "ciclo",
        field: "ciclo",
        label: "Ciclo",
        component: MInput,
        className: "col-md-2 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_Ssis = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
    ciclo: "",
  };

  static COBASLID = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Denominazione titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_COBASLID = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static DiplomaAccademicoAFAM = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Denominazione titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_DiplomaAccademicoAFAM = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static DiplomaDidatticaMusica = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Denominazione titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_DiplomaDidatticaMusica = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
  };

  static ConcorsoTitoliEsami = [
    [
      {
        id: "description",
        field: "description",
        label: "Riferimento concorso",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "ufficioScolastico",
        field: "ufficioScolastico",
        label: "Ufficio Scolastico Regionale/Provinciale di competenza",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data concorso",
        component: MInput,
        type: "date",
        className: "col-md-4 pt-3",
      },
    ],
    [
      {
        field: "attachment",
        label:
          "(Per i titoli di abilitazione conseguiti a seguito di concorso si prega di inserire idonea certificazione)",
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
  ];

  static dv_ConcorsoTitoliEsami = {
    description: "",
    dataConseguimento: "",
    ufficioScolastico: "",
  };

  static SessioniRiservateAbilitazioni = [
    [
      {
        id: "description",
        field: "description",
        label: "Denominazione titolo",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "ufficioScolastico",
        field: "ufficioScolastico",
        label: "Ufficio Scolastico Regionale/Provinciale di competenza",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data concorso",
        component: MInput,
        type: "date",
        className: "col-md-4 pt-3",
      },
    ],
    [
      {
        field: "attachment",
        label:
          "(Per i titoli di abilitazione conseguiti a seguito di concorso si prega di inserire idonea certificazione)",
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
  ];

  static dv_SessioniRiservateAbilitazioni = {
    description: "",
    istitution: "",
    aa: "",
    dataConseguimento: "",
    ufficioScolastico: "",
  };

  static Tfa = [
    [
      {
        id: "searchUniversity",
        component: MButton2,
        onClick: () => {
          console.error("errore: event unhandled");
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso", // diverse label
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        id: "city",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        id: "description",
        field: "description",
        label: "Classe di abilitazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "ciclo",
        field: "ciclo",
        label: "Ciclo",
        component: MInput,
        className: "col-md-2 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-5 pt-3",
      },
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-5 pt-3",
      },
    ],
  ];

  static dv_Tfa = {
    description: "",
    istitution: "",
    city: "",
    aa: "",
    dataConseguimento: "",
    ciclo: "",
  };

  static TitoloEsteroRiconosciuto = [
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso l'Università",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "nation",
        field: "nation",
        label: "Nazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "riconoscimentoMIUR",
        field: "riconoscimentoMIUR",
        label: "Estremi Decreto MIUR di riconoscimento",
        component: MInput,
        type: "text",
        className: "col-md-10",
      },
      {
        id: "dataDecreto",
        field: "dataDecreto",
        label: "Data",
        component: MInput,
        type: "date",
        className: "col-md-2 pt-3",
      },
    ],
    [
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data concorso",
        component: MInput,
        type: "date",
        className: "col-md-4 pt-3",
      },
    ],
  ];

  static dv_TitoloEsteroRiconosciuto = {
    istitution: "",
    nation: "",
    aa: "",
    dataConseguimento: "",
    riconoscimentoMIUR: "",
    dataDecreto: "",
  };

  static TitoloEsteroPresentataDomandaRiconoscimento = [
    [
      {
        id: "aa1",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 pt-3",
      },
      {
        id: "dataConseguimento1",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-4 pt-3",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso l'Università",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "nation",
        field: "nation",
        label: "Nazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dataPresentazioneDomanda",
        field: "dataPresentazioneDomanda",
        label: "Data di presentazione della domanda di riconoscimento",
        component: MInput,
        type: "date",
        className: "col-md-6 pt-3",
      },
      {
        id: "numProtocollo",
        field: "numProtocollo",
        label: "Prot. n.",
        component: MInput,
        className: "col-md-6 pt-3",
      },
    ],
  ];

  static dv_TitoloEsteroPresentataDomandaRiconoscimento = {
    istitution: "",
    aa: "",
    dataConseguimento: "",
    dataPresentazioneDomanda: "",
    numProtocollo: "",
    nation: "",
  };

  static getDefaultValues(template) {
    return this["dv_" + template];
  }

  static getFields(template, onSelectedUniversity, onSelectedSchool) {
    const fieldGroup = this[template];

    if (fieldGroup) {
      if (fieldGroup[0] && fieldGroup[0][0].id === "searchUniversity") {
        fieldGroup[0][0].onClick = onSelectedUniversity;
      } else if (fieldGroup[0] && fieldGroup[0][0].id === "searchSchool") {
        fieldGroup[0][0].onClick = onSelectedSchool;
      }
    } else {
      console.error(template + " not found");
    }
    return fieldGroup;
  }

  static getExtCode(template) {
    return this.extCode[template];
  }
}
